"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_lottie_player_1 = require("@lottiefiles/react-lottie-player");
var loader_json_1 = __importDefault(require("./loader.json"));
function BravasLoading(_a) {
    var size = _a.size;
    return ((0, jsx_runtime_1.jsx)(react_lottie_player_1.Player, { src: loader_json_1.default, loop: true, autoplay: true, style: { height: size, width: size } }));
}
exports.default = BravasLoading;
BravasLoading.defaultProps = {
    size: '50px',
};
//# sourceMappingURL=BravasLoading.js.map